import React from "react";
import "./photo-gallery.scss";

interface PhotoGalleryProps {
    imageSources: ImageSourceType[]
    isImageBordered?: boolean;

    className?: string;
}
export interface ImageSourceType {
    src: string;
    altTitle: string;
    figcaptionFirstTitle: string;
    figcaptionSecondTitle?: string;
}
export const PhotoGallery = (props: PhotoGalleryProps) => {
    return (
        <div className="gallery">
            {
                props.imageSources.map((item: ImageSourceType) => {
                    return (
                        <div className="gallery__figure-content">
                            <figure key={item.altTitle}>
                                <img src={item.src} alt={item.altTitle} />
                                <figcaption>{item.figcaptionFirstTitle}</figcaption>
                                {item.figcaptionSecondTitle &&
                                    <figcaption>{item.figcaptionSecondTitle}</figcaption>
                                }
                            </figure>
                        </div>
                    )
                })
            }
        </div>
    )
}